import React from 'react';
import styles from './style.module.scss';
import classNames from 'classnames';

export default function RoleCheckBox({ isActive, ChekcboxContainerStyle, CheckboxStyle, handleClick, title, labelStyle }) {
    return (
        <div className="d-flex">
            <label className={classNames(ChekcboxContainerStyle && ChekcboxContainerStyle, styles.container)}>
                <input type="checkbox" checked={isActive} onChange={handleClick} />
                <span className={classNames(styles.checkmark, CheckboxStyle && CheckboxStyle, styles.active)}></span>
            </label>
        </div>
    );
}
